import { addAccountsToGroupBulkActionType } from '../../../../../../../backend/features/accounts/shared';
import { showGroupsDialog } from '../../../../../../../ui/features/groups/components/GroupsPanel/components/GroupsDialog';
import { getFilterForBulkAction } from '../../../../../../../utils';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
export function handleAddToExistingGroup({ t, accountIds, appliedStorageFilters, onClose }) {
    showGroupsDialog({
        excludeFilterBasedGroups: true,
        onSelect: (selectedGroupId) => {
            if (typeof selectedGroupId === 'string') {
                launchBulkAction({
                    type: addAccountsToGroupBulkActionType,
                    title: t('panels.groups.addingAccountsToGroup'),
                    params: {
                        groupId: selectedGroupId,
                        filter: getFilterForBulkAction(accountIds, appliedStorageFilters),
                    },
                    onClose,
                });
            }
        },
    });
}
